import React, { useEffect, useState } from "react";
import { useLocation } from "react-router-dom";

import LdsButton from "../../components/LdsButton";
import LdsTile from "../../components/LdsTile";
import LdsLink from "../../components/LdsLink";
import correctBox from "../../assets/module-4/correct.svg";
import incorrectBox from "../../assets/module-4/incorrect.svg";
import { SideBar } from "../../components/SideBar";
import { useSelector } from "react-redux";

import { ReactLoaderSpinner } from "../../components/ReactLoaderSpinner/index.js";

// services
import { useBookmarkModuleMutation, useGetAllQuestionAnswerQuery } from "../../store/services/moduleServerApi";

const Module_1_0 = () => {
  const moduleNumber = 4
  const { pathname: pathName } = useLocation();
  const { menuItems, allQuestionAnswered = [] } = useSelector((state) => state?.moduleSlice);

  console.log('allQuestionAnswered :>> ', allQuestionAnswered);
  // tart state
  const [skipGetAllQuestionAnswerQuery, setSkipGetAllQuestionAnswerQuery] = useState();

  // start service call
  useGetAllQuestionAnswerQuery(4, {
    skip: skipGetAllQuestionAnswerQuery,
  });

  const [bookmarkModule, { isLoading: isMenuLoading }] =
    useBookmarkModuleMutation();

  /* Start useEffect */
  useEffect(() => {
    bookmarkModule({ pathName });
    setSkipGetAllQuestionAnswerQuery(true);
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []); // * onPageLoad
  /* End useEffect */

  // custom function
  const renderQuestionAnswer = (questions = []) => {
    return questions?.map(({ answer, modulePath, questionLabel }) => {
      return (<div className="dashboard-link mb-3">
        <LdsLink
          href={modulePath}
          className="no-underline"
        >
          {questionLabel}
        </LdsLink>
        {answer && <img
          src={answer?.toLowerCase() === "correct" ? correctBox : incorrectBox}
          alt={`Case 1 ${answer}`}
          className="ps-3"
        />}
      </div>)
    })
  }

  const renderQuestionAnswerCart = (sections = []) => {
    return sections.map(({ questions = [] }) => {
      return (<div className={`col-sm-12 ${sections.length > 2 ? 'col-md-3' : 'col-md-6'}`}>
        {renderQuestionAnswer(questions)}
      </div>)
    })
  }

  return (
    <div className="row">
      {isMenuLoading && <ReactLoaderSpinner />}
      {menuItems?.id && <SideBar menuItems={[menuItems]} moduleNumber={moduleNumber} />}

      <main className="col-sm-8 410-dashboard">
        <section className="module-content">
          <h1 className="blue text-uppercase b mt-5 mb-4">
            4.1.0 Additional Challenge Cases Dashboard
          </h1>
          <p className="me-4">Estimated time to complete: 1 minute</p>
        </section>
        <section className="section">
          <h2 className="h5 b mb-1">Step 1: Please click on a case to begin</h2>
          <p className="mb-4">
            Challenge cases were grouped for your selection according to their
            most prominent attribute. Categories may overlap and are not meant
            to imply degree of scan interpretation difficulty.
          </p>
          <div className="row">
            {allQuestionAnswered?.length ? allQuestionAnswered.map(({ parentTitle, sections = [] }) => {
              return (
                <div className={`col-sm-12 mt-100 ${sections?.length < 3 && 'col-md-6'}`}>
                  <LdsTile
                    ariaLabel="Motion/Noise/Positioning"
                    className=""
                    role="region"
                  >
                    <LdsTile.Body className="p-4">
                      <div className="row">
                        <h3 className="h6 b mb-4">{parentTitle}</h3>
                        {renderQuestionAnswerCart(sections)}
                      </div>
                    </LdsTile.Body>
                  </LdsTile>
                </div>
              )
            }) : null}

            {/* <div className="col-sm-12 col-md-6">
              <LdsTile
                ariaLabel="Motion/Noise/Positioning"
                className=""
                role="region"
              >
                <LdsTile.Body className="p-4">
                  <div className="row">
                    <h3 className="h6 b mb-4">Motion/Noise/Positioning</h3>
                    <div className="col-sm-12 col-md-6">
                      <div className="dashboard-link mb-3">
                        <LdsLink
                          href="/module-4/module-4-1-1"
                          className="no-underline"
                        >
                          Case 1
                        </LdsLink>
                        <img
                          src={correctBox}
                          alt="Case 1 Correct"
                          className="ps-3"
                        />
                      </div>
                      <div className="dashboard-link mb-3">
                        <LdsLink
                          href="/module-4/module-4-1-2"
                          className="no-underline"
                        >
                          Case 2
                        </LdsLink>
                        <img
                          src={incorrectBox}
                          alt="Case 1 Incorrect"
                          className="ps-3"
                        />
                      </div>
                      <div className="dashboard-link mb-3">
                        <LdsLink
                          href="/module-4/module-4-1-3"
                          className="no-underline"
                        >
                          Case 3
                        </LdsLink>
                      </div>
                    </div>

                    <div className="col-sm-12 col-md-6">
                      <LdsLink
                        href="/module-4/module-4-1-7"
                        className="d-block mb-3 no-underline"
                      >
                        Case 7
                      </LdsLink>
                      <LdsLink
                        href="/module-4/module-4-1-14"
                        className="d-block mb-3 no-underline"
                      >
                        Case 14
                      </LdsLink>
                    </div>
                  </div>
                </LdsTile.Body>
              </LdsTile>
            </div>
            <div className="col-sm-12 col-md-6">
              <LdsTile
                ariaLabel="Anatomic Variant/Atrophy"
                className=""
                role="region"
              >
                <LdsTile.Body className="p-4">
                  <div className="row">
                    <h3 className="h6 b mb-4">Anatomic Variant/Atrophy</h3>
                    <div className="col-sm-12 col-md-6">
                      <div className="dashboard-link mb-3">
                        <LdsLink
                          href="/module-4/module-4-1-4"
                          className="no-underline"
                        >
                          Case 4
                        </LdsLink>
                      </div>
                      <div className="dashboard-link mb-3">
                        <LdsLink
                          href="/module-4/module-4-1-6"
                          className="no-underline"
                        >
                          Case 6
                        </LdsLink>
                      </div>
                      <div className="dashboard-link mb-3">
                        <LdsLink
                          href="/module-4/module-4-1-10"
                          className="no-underline"
                        >
                          Case 10
                        </LdsLink>
                      </div>
                    </div>
                    <div className="col-sm-12 col-md-6">
                      <div className="dashboard-link mb-3">
                        <LdsLink
                          href="/module-4/module-4-1-15"
                          className="no-underline"
                        >
                          Case 15
                        </LdsLink>
                      </div>
                      <div className="dashboard-link mb-3">
                        <LdsLink
                          href="/module-4/module-4-1-16"
                          className="no-underline"
                        >
                          Case 16
                        </LdsLink>
                      </div>
                      <div className="dashboard-link mb-3">
                        <LdsLink
                          href="/module-4/module-4-1-20"
                          className="no-underline"
                        >
                          Case 20
                        </LdsLink>
                      </div>
                    </div>
                  </div>
                </LdsTile.Body>
              </LdsTile>
            </div>
            <div className="col-sm-12 mt-125">
              <LdsTile
                ariaLabel="Anatomic Variant/Atrophy"
                className=""
                role="region"
              >
                <LdsTile.Body className="p-4">
                  <div className="row">
                    <h3 className="h6 b mb-4">Anatomic Variant/Atrophy</h3>
                    <div className="col-sm-12 col-md-6">
                      <div className="dashboard-link mb-3">
                        <LdsLink
                          href="/module-4/module-4-1-4"
                          className="no-underline"
                        >
                          Case 4
                        </LdsLink>
                      </div>
                      <div className="dashboard-link mb-3">
                        <LdsLink
                          href="/module-4/module-4-1-6"
                          className="no-underline"
                        >
                          Case 6
                        </LdsLink>
                      </div>
                      <div className="dashboard-link mb-3">
                        <LdsLink
                          href="/module-4/module-4-1-10"
                          className="no-underline"
                        >
                          Case 10
                        </LdsLink>
                      </div>
                    </div>
                    <div className="col-sm-12 col-md-6">
                      <div className="dashboard-link mb-3">
                        <LdsLink
                          href="/module-4/module-4-1-15"
                          className="no-underline"
                        >
                          Case 15
                        </LdsLink>
                      </div>
                      <div className="dashboard-link mb-3">
                        <LdsLink
                          href="/module-4/module-4-1-16"
                          className="no-underline"
                        >
                          Case 16
                        </LdsLink>
                      </div>
                      <div className="dashboard-link mb-3">
                        <LdsLink
                          href="/module-4/module-4-1-20"
                          className="no-underline"
                        >
                          Case 20
                        </LdsLink>
                      </div>
                    </div>
                  </div>
                </LdsTile.Body>
              </LdsTile>
            </div> */}
          </div>
        </section>
        <section className="button-control">
          <LdsButton
            classes="white-button mt-3 mb-5 prev"
            onClick={function navClick() {
              window.open("/module-4/module-4-0-0", "_self");
            }}
          >
            Previous Lesson
          </LdsButton>
          <LdsButton
            classes="blue-button mt-3 mb-5 align-self-right float-end next"
            onClick={function navClick() {
              window.open("/module-4/module-4-1-1", "_self");
            }}
          >
            Next Lesson
          </LdsButton>
        </section>
      </main>
    </div>
  );
};

export default Module_1_0;
